import Condominium from './condominium';

export default Condominium;
